/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionBotexamidLangGrid200,
  GetApiV1ExamRevisionBotexamidLangGrid401,
  GetApiV1ExamRevisionBotexamidLangGrid404,
  GetApiV1ExamRevisionBotexamidLangGrid500,
  GetApiV1ExamRevisionBotexamidLangGridPathParams,
  GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidLangGrid.ts";
import { classroomDisciplineBotExamLangGridItemViewModelSchema } from "../classroomDisciplineBotExamLangGridItemViewModelSchema.ts";

export const getApiV1ExamRevisionBotexamidLangGridPathParamsSchema = z.object({
  botExamId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGridPathParams>;

export const getApiV1ExamRevisionBotexamidLangGridQueryParamsSchema = z.object({
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionBotexamidLangGrid200Schema = z.array(
  z.lazy(() => classroomDisciplineBotExamLangGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGrid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionBotexamidLangGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGrid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamRevisionBotexamidLangGrid404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGrid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionBotexamidLangGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGrid500>;

export const getApiV1ExamRevisionBotexamidLangGridQueryResponseSchema = z.lazy(
  () => getApiV1ExamRevisionBotexamidLangGrid200Schema,
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidLangGridQueryResponse>;
